import React, { memo, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import configServ from "../../../services/config";
import { useSelector } from "react-redux";

const PainAreaForm = ({ formData, setFormData, setItem_id, setMuscleCode, diagnosisData }) => {
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };
  const [subCategory, setSubCategory] = useState([]);
  const [category, setCategory] = useState([]);
  const [painareas, setPainareas] = useState([]);
  const { user_id, company_id, noRoomService } = useSelector(
    (state) => state.GlobalVariables
  );

  const [loading, setLoading] = useState(false);
  const fetchActiveSubCategory = async () => {
    try {
      setLoading(true);
      const dataToSend = {
        category: 1,
      };
      const res = await configServ.getActiveGroup(dataToSend);
      if (res.status === 200) {
        setSubCategory(res.data);
      } else {
        setSubCategory([]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetchActiveAllCategories = async () => {
    try {
      const res = await configServ.getActiveCategoryAll();
      if (res.status === 200) {
        setCategory(res.data);
      } else {
        setCategory([]);
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    fetchActiveAllCategories();
    fetchItemList();
    fetchActiveSubCategory();
  }, []);

  const fetchItemList = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getItemList(dataToSend);
      if (res.status === 200) {
        setPainareas(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (diagnosisData?.item_id && painareas.length > 0) {
      const selectedItem = painareas.find((item) => item.id === diagnosisData.item_id);
      if (selectedItem) {
        setFormData((prev) => ({
          ...prev,
          item_name: selectedItem.item_name,
          item_id: selectedItem.id,
          item_code: selectedItem.item_code,
        }));
        setItem_id?.(selectedItem.id);
        setMuscleCode?.(selectedItem.group_id);
      }
    }
  }, [diagnosisData, painareas]);
  

  return (
    <Box sx={{ p: 0, bgcolor: "#e3f3fc", borderRadius: 2, mt:2 }}>
      <Paper
        elevation={1}
        sx={{ px: 2, py: 1, backgroundColor: "transparent" }}
      >
        <Typography
          variant="body1"
          fontWeight="bold"
          color="#1e61b4"
          gutterBottom
        >
          Pain Area Details
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <FormControl fullWidth>
              <InputLabel> Select Pain Area's</InputLabel>
              <Select
                value={formData.item_name || ""}
                sx={{ backgroundColor: "white" }}
                onChange={(e) => {
                  const selectedItem = painareas.find(
                    (item) => item.item_name === e.target.value
                  );
                  setFormData({
                    ...formData,
                    item_name: selectedItem?.item_name || "",
                    item_id: selectedItem?.id || "",
                    item_code: selectedItem?.item_code || "",
                  });
                  setItem_id?.(selectedItem?.id || "");
                  setMuscleCode?.(selectedItem?.group_id || "");
                }}
              >
                {painareas.map((item) => (
                  <MenuItem key={item.id} value={item.item_name}>
                    {item.item_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* <Grid item xs={6} sm={4} md={3}>
            <FormControl fullWidth>
              <InputLabel>Area</InputLabel>
              <Select
                value={formData.group_name || ""}
                onChange={handleChange("group_name")}
              >
                {subCategory.map((item) => (
                  <MenuItem key={item.id} value={item.group_name}>
                    {item.group_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4} md={3}>
            <FormControl fullWidth>
              <InputLabel>Category</InputLabel>
              <Select
                value={formData.categoryname || ""}
                onChange={handleChange("categoryname")}
              >
                {category.map((item) => (
                  <MenuItem key={item.id} value={item.categoryname}>
                    {item.categoryname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid> */}

          {/* <Grid item xs={6} sm={4} md={3}>
            <FormControl fullWidth>
              <InputLabel>Speciality</InputLabel>
              <Select
                value={formData.brand_name || ""}
                onChange={handleChange("brand_name")}
              >
                <MenuItem value="Orthopedic">Orthopedic</MenuItem>
                <MenuItem value="Physiotherapy">Physiotherapy</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
        </Grid>
      </Paper>
    </Box>
  );
};

export default memo(PainAreaForm);
